import { useEffect, useRef } from "react";
import { Stack, Button, Tabs } from "@mui/material";
import { CategoryButton } from "~components/atoms";
import { AddIcon } from "~components/Icons";
import { useProductsContext } from "~contexts/Products";

const CategoryTabs = () => {
  const tabsRef = useRef<HTMLDivElement | null>(null);
  const tabsActionRef = useRef<any>(null);
  const hasInitializedRef = useRef<boolean>(false);
  const { buttons, setButtons, buttonActive, setButtonActive, addRandomButton } =
    useProductsContext();

  const orderedButtons = [...buttons].sort((a, b) => parseFloat(a.x) - parseFloat(b.x));

  useEffect(() => {
    // Garante que as setas sejam calculadas/renderizadas no primeiro mount
    tabsActionRef.current?.updateIndicator?.();
    tabsActionRef.current?.updateScrollButtons?.();
  }, [orderedButtons.length]);

  useEffect(() => {
    if (!orderedButtons.length) {
      hasInitializedRef.current = false;
      return;
    }

    const hasValidSelection = buttonActive >= 0 && buttonActive < orderedButtons.length;
    if (!hasValidSelection) {
      setButtonActive(0);
      return;
    }

    requestAnimationFrame(() => {
      const activeButton = tabsRef.current?.querySelector("button.isActive") as HTMLButtonElement | null;
      if (!activeButton) return;

      activeButton.scrollIntoView({
        behavior: hasInitializedRef.current ? "smooth" : "auto",
        inline: "nearest",
        block: "nearest",
      });
      hasInitializedRef.current = true;
    });
  }, [buttonActive, orderedButtons.length, setButtonActive]);

  return (
    <Stack
      justifyContent="space-between"
      alignItems="center"
      direction="row"
      sx={{
        mb: 1.375,
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",
      }}
    >
      <Tabs
        sx={{
          flex: 1,
          minWidth: 0,
          maxWidth: "100%",
          overflow: "hidden",
          "& .MuiTabs-scrollButtons": {
            opacity: "1 !important",
          },
        }}
        action={tabsActionRef}
        value={false}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        ref={tabsRef}
      >
        <Stack
          alignItems="center"
          direction="row"
          sx={{ height: "56px", width: "max-content", pr: 2 }}
        >
          {orderedButtons.map((button, index) => (
            <CategoryButton
              key={index}
              index={index}
              button={button}
              buttons={orderedButtons}
              setButtons={setButtons}
              buttonActive={buttonActive}
              setButtonActive={setButtonActive}
            />
          ))}
        </Stack>
      </Tabs>

      <Button
        sx={{
          width: "196px",
          flexShrink: 0,
          ml: 2,
        }}
        variant="secondaryButton"
        endIcon={<AddIcon />}
        onClick={() => addRandomButton()}
      >
        adicionar categoria
      </Button>
    </Stack>
  );
};

export default CategoryTabs;
